module.exports = __webpack_public_path__ + "static/media/story-7-1.5f8e7582.JPG";